import { render } from "./FeedbackCreated.vue?vue&type=template&id=1f24e23e"
import script from "./FeedbackCreated.vue?vue&type=script&lang=js"
export * from "./FeedbackCreated.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__